module.exports = __webpack_public_path__ + "img/av_dragonfly.08cea848.png";